export default class ResultsSummaryModel {
  public questions: number = null;
  public correctAnswers: number = null;
}
